import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { updatePractice } from 'api/Practice';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';

import ImageUploader from 'components/shared/ImageUploader/ImageUploader';
import {
  isSubstepCompleted,
  resolveContinueAction
} from 'components/shared/OnboardingWizard/lib/resolveContinueAction';

const PracticeBrandingForm = ({
  addFooterActions,
  setHeaderButtonProps,
  mutateOrchestratorData,
  onNext,
  orchestratorData,
  orchestratorLoading
}) => {
  const { practice } = useOutletContext();
  const navigate = useNavigate();
  const [header_photo, setHeaderPhoto] = useState(practice?.header_photo || null);

  const updatePracticeMutation = useCustomMutation({
    mutationFn: () =>
      updatePractice(navigate, {
        practice_id: practice.id,
        fields: {
          header_photo
        }
      }),
    disableAlert: true
  });

  const handleSubmit = resolveContinueAction({
    isDirty: header_photo !== practice?.header_photo,
    isCompleted: isSubstepCompleted(orchestratorData),
    hasExistingData: !!practice?.header_photo,
    onSave: async () => {
      await updatePracticeMutation.mutateAsync();
      mutateOrchestratorData();
    },
    onConfirm: () => mutateOrchestratorData(),
    onNext
  });

  useEffect(() => {
    setHeaderButtonProps(null);
    addFooterActions([
      {
        text: 'Continue',
        onClick: handleSubmit,
        disabled: orchestratorLoading
      }
    ]);
  }, [header_photo, orchestratorData?.handlerStatus, orchestratorLoading]);

  return (
    <>
      <div className="w-full">
        <ImageUploader
          handlers={
            header_photo ? [JSON.parse(header_photo)[Object.keys(JSON.parse(header_photo))[0]]] : []
          }
          onDelete={() => {
            setHeaderPhoto(null);
          }}
          onUpload={(file) => {
            const ext = file.name.split('.').pop();
            const minimal = { [ext]: file.handle };

            const header_photo = JSON.stringify(minimal);
            setHeaderPhoto(header_photo);
          }}
        />
      </div>
    </>
  );
};

export default PracticeBrandingForm;
